(function () {
  'use strict';
  if (window.__spQA == null) window.__spQA = (function () { var q = /[?&]sp_qa=([01])(?:&|$)/.exec(location.search), s = false; try { if (q) localStorage.setItem('sp_qa', q[1]); s = localStorage.getItem('sp_qa') === '1'; } catch (e) {} var r = window.Shopify && window.Shopify.theme && window.Shopify.theme.role; return s || /^(localhost|127\.0\.0\.1)$/.test(location.hostname) || /SimplePaperQA/.test(navigator.userAgent) || (!!r && r !== 'main'); })();
  if (window.__spNavTracking) return;
  window.__spNavTracking = true;

  var queue = [];
  var consent = null;

  function allowed() {
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (!api || typeof api.analyticsProcessingAllowed !== 'function') return null;
      return !!api.analyticsProcessingAllowed();
    } catch (e) { return null; }
  }
  function deliver(name, props) {
    if (window.__spQA) return;
    try { if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(name, props); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, props); } catch (e) {}
  }
  function send(name, props) {
    if (consent === true) { deliver(name, props); return; }
    if (consent === false) return;
    if (queue.length < 20) queue.push([name, props]);
  }
  function settle() {
    var a = allowed();
    if (a === null) return;
    consent = a;
    if (a) queue.forEach(function (q) { deliver(q[0], q[1]); });
    queue.length = 0;
  }
  settle();
  document.addEventListener('visitorConsentCollected', settle);
  window.setTimeout(settle, 1200);
  window.setTimeout(function () { if (consent === null) { consent = false; queue.length = 0; } }, 8000);

  var HEAD = '.sp-mega__col-head, .sp-mega__title, .sp-mega__eyebrow, .sp-mega__tiles-head';

  function clean(t) { return (t || '').replace(/\s+/g, ' ').trim().slice(0, 60); }
  // Raw text, never innerText: innerText applies CSS text-transform, so the drawer's
  // uppercase rows would report "STATIONERY" against the desktop's "Stationery". A row
  // with a subtitle badge carries its name in .sp-row-label; badges and icons are skipped.
  var SKIP = 'svg, img, .sp-row-badge, .sp-mega__tile-thumb, .visually-hidden';
  function txt(el) {
    if (!el) return '';
    var own = el.querySelector(':scope > .sp-row-label');
    if (own) return clean(own.textContent);
    var parts = [];
    Array.prototype.forEach.call(el.childNodes, function (n) {
      if (n.nodeType === 3) parts.push(n.nodeValue);
      else if (n.nodeType === 1 && !n.matches(SKIP)) parts.push(n.textContent);
    });
    return clean(parts.join(' ')) || clean(el.getAttribute && el.getAttribute('aria-label'));
  }
  function path(a) {
    try { return a.href ? new URL(a.href, location.href).pathname : ''; } catch (e) { return ''; }
  }
  function deviceMenu() {
    return window.matchMedia && window.matchMedia('(max-width: 767.98px)').matches ? 'mobile' : 'desktop';
  }

  // The tier-1 item a node sits under, by its own link text.
  function panelOf(node) {
    var li = null, e = node;
    while (e && e !== document.body) {
      if (e.matches && e.matches('li.navigation__item') && e.parentElement && e.parentElement.classList.contains('navigation__tier-1')) { li = e; break; }
      e = e.parentElement;
    }
    return li ? txt(li.querySelector(':scope > .navigation__link')) : '';
  }

  // A heading row can hold its own "Shop all" link; that link is not part of the name.
  function headText(el) {
    var t = el.textContent || '';
    Array.prototype.forEach.call(el.querySelectorAll('a'), function (x) { t = t.replace(x.textContent, ' '); });
    return clean(t);
  }

  // Desktop: the nearest heading before the link inside its mega panel.
  function megaSection(a) {
    var e = a, stop = a.closest('.sp-mega');
    while (e && e !== stop) {
      var s = e.previousElementSibling;
      while (s) {
        if (s.matches(HEAD)) return headText(s);
        var inner = s.querySelectorAll(HEAD);
        if (inner.length) return headText(inner[inner.length - 1]);
        s = s.previousElementSibling;
      }
      e = e.parentElement;
    }
    return '';
  }

  // Drawer: the tier-2 group a tier-3 link belongs to.
  function drawerSection(a) {
    if (a.closest('.sp-mega-mobile')) return 'Featured';
    var tier3 = a.closest('.navigation__tier-3-container');
    if (!tier3) return '';
    var group = tier3.closest('li.navigation__item');
    return group ? txt(group.querySelector(':scope > .navigation__link')) : '';
  }

  function positionOf(a) {
    var li = a.closest('li');
    if (!li || !li.parentElement) return 1;
    // A panel link outside any list (a feature CTA) lands on its tier-1 <li>; that is not its list.
    if (li.parentElement.classList.contains('navigation__tier-1') && a.parentElement !== li) return 1;
    var items = Array.prototype.filter.call(li.parentElement.children, function (x) { return x.tagName === 'LI'; });
    var i = items.indexOf(li);
    return i < 0 ? 1 : i + 1;
  }

  function classify(el) {
    var header = el.closest('[id$="__header"], .section-header');
    var drawer = el.closest('.mobile-navigation-drawer');
    if (drawer) return 'mobile_drawer';
    if (!header) return '';
    if (el.closest('.sp-hsearch, main-search, .main-search, .show-search-link')) return 'header_search';
    if (el.closest('main-navigation, .navigation')) return 'desktop_mega';
    if (el.closest('.cart-link, .header-account-link, shopify-account, .logo__link')) return 'header_icon';
    return '';
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var a = t.closest('a[href], shopify-account');
    if (!a) return;
    var surface = classify(a);
    if (!surface) return;
    var href = a.getAttribute && a.getAttribute('href');
    // Accordion chevrons and "#" toggles are opens, reported by sp_nav_open.
    if (a.tagName === 'A' && (!href || href === '#' || a.classList.contains('navigation__children-toggle') || a.classList.contains('mobile-nav-toggle') || a.classList.contains('mobile-nav-back'))) return;
    var section = surface === 'desktop_mega' ? megaSection(a) : surface === 'mobile_drawer' ? drawerSection(a) : '';
    var lab = a.tagName === 'SHOPIFY-ACCOUNT' ? 'Account' : (a.classList.contains('logo__link') ? 'Logo' : txt(a));
    send('sp_nav_click', {
      surface: surface,
      panel: surface === 'desktop_mega' || surface === 'mobile_drawer' ? panelOf(a) : '',
      section: section,
      label: lab,
      target: a.tagName === 'A' ? path(a) : '/account',
      position: positionOf(a),
      device_menu: deviceMenu()
    });
  }, true);

  /* ---------- opens ---------- */
  var held = new WeakMap();
  function watch(root, surface) {
    if (!root || !window.MutationObserver) return;
    new MutationObserver(function (list) {
      list.forEach(function (m) {
        var li = m.target;
        if (!li.matches || !li.matches('li.navigation__item')) return;
        var was = (m.oldValue || '').split(/\s+/);
        if (surface === 'desktop_mega') {
          var on = li.classList.contains('navigation__item--show-children');
          if (!on || was.indexOf('navigation__item--show-children') > -1) return;
          if (held.get(li)) clearTimeout(held.get(li));
          held.set(li, setTimeout(function () {
            if (li.classList.contains('navigation__item--show-children')) send('sp_nav_open', { surface: surface, panel: panelOf(li), section: '' });
          }, 500));
        } else {
          if (!li.classList.contains('navigation__item--open') || was.indexOf('navigation__item--open') > -1) return;
          var tier1 = li.parentElement && li.parentElement.classList.contains('navigation__tier-1');
          send('sp_nav_open', { surface: surface, panel: panelOf(li), section: tier1 ? '' : txt(li.querySelector(':scope > .navigation__link')) });
        }
      });
    }).observe(root, { subtree: true, attributes: true, attributeFilter: ['class'], attributeOldValue: true });
  }

  function start() {
    watch(document.querySelector('main-navigation'), 'desktop_mega');
    watch(document.querySelector('.mobile-navigation-drawer'), 'mobile_drawer');
    if (window.MutationObserver) {
      new MutationObserver(function (list) {
        list.forEach(function (m) {
          var was = (m.oldValue || '').split(/\s+/).indexOf('reveal-mobile-nav') > -1;
          if (!was && document.body.classList.contains('reveal-mobile-nav')) send('sp_nav_open', { surface: 'mobile_drawer', panel: '', section: '' });
        });
      }).observe(document.body, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
